
// dark theme
export const dark = {

    // background colors
    
    mainBgColor: "#333434",
    secondaryBgColor: "#4D4D4D",
    contrastColor: "#b8bab9",
    transitionColor: "#646464",

    mainColorTranparent:"rgba(235, 176, 14, .08)",

    // text colors
    mainTextColor: "#D4D4D4",
    reverseMainTextColor: "#3D3D3B",
    secondaryTextColor: "#b0aea9",

    activeColor: "#BB2649",
    colorYellow: "#EBB00E",
    colorGreen: "#0EAC00",

    /// border colors
    mainBorderColor: "#5e5e5e",
    contrastBorderColor: "#858181",

    rotaPlanlamaIndexBgColor: "#EBB00E",

    // sadece dark theme de lazım bu
    inputDateIconColor: "invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)",

    utilityBtnBg: "#7d7c7c",

    scrollThumbColor: "#454545",

    accTopColor:"#4a4949",
    accBottomColor: "#403d3d",

    rotaPointColor: "#fff"
}

// light theme
export const light = {

    // background colors
    mainBgColor: "#fff",
    secondaryBgColor: "#f0eded",
    contrastColor: "#000",
    transitionColor: "#dedcdc",

    mainColorTranparent:"rgba(235, 176, 14, .08)",

    // text colors
    mainTextColor: "#000",
    reverseMainTextColor: "#fff",
    secondaryTextColor: "#b0aea9",

    activeColor: "#BB2649",
    colorYellow: "#EBB00E",
    colorGreen: "#0EAC00",

    /// border colors
    mainBorderColor: "#E2E2E2",
    contrastBorderColor: "#858181",

    rotaPlanlamaIndexBgColor: "#3C3C3B",

    utilityBtnBg: "#7b7a7a",
    scrollThumbColor: "#dadada",


    accTopColor:"#F5F5F5",
    accBottomColor: "#E8E8E8",

    rotaPointColor: "transparent"

}